import { Action, ActionCreator } from 'redux'
import { History } from 'history'

export enum UserTypes {
  SET_SESSION_TRIGGER = 'SET_SESSION_TRIGGER',
  SET_SESSION_REQUEST = 'SET_SESSION_REQUEST',
  SET_SESSION_SUCCESS = 'SET_SESSION_SUCCESS',
  SET_SESSION_FAILURE = 'SET_SESSION_FAILURE',
  SET_SESSION_FULFILL = 'SET_SESSION_FULFILL',
  LOGIN_TRIGGER = 'LOGIN_TRIGGER',
  LOGIN_REQUEST = 'LOGIN_REQUEST',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_FAILURE = 'LOGIN_FAILURE',
  LOGIN_FULFILL = 'LOGIN_FULFILL',
  LOGOUT_TRIGGER = 'LOGOUT_TRIGGER',
  LOGOUT_REQUEST = 'LOGOUT_REQUEST',
  LOGOUT_SUCCESS = 'LOGOUT_SUCCESS',
  LOGOUT_FAILURE = 'LOGOUT_FAILURE',
  LOGOUT_FULFILL = 'LOGOUT_FULFILL',
  FORGOT_TRIGGER = 'FORGOT_TRIGGER',
  FORGOT_SUCCESS = 'FORGOT_SUCCESS',
  FORGOT_ERROR = 'FORGOT_ERROR',
  FETCH_RECOVERPASSWORD_REJECTED = 'FETCH_RECOVERPASSWORD_REJECTED',
  FETCH_RECOVERPASSWORD_FULFILLED = 'FETCH_RECOVERPASSWORD_FULFILLED',
}

export interface SetSessionTriggerAction extends Action {
  readonly type: UserTypes.SET_SESSION_TRIGGER;
  readonly payload: SessionPayload;
}

export interface SetSessionRequestAction extends Action {
  readonly type: UserTypes.SET_SESSION_REQUEST;
}

export interface SetSessionSuccessAction extends Action {
  readonly type: UserTypes.SET_SESSION_SUCCESS;
  readonly payload: SessionPayload;
}

export interface SetSessionFailureAction extends Action {
  readonly type: UserTypes.SET_SESSION_FAILURE;
  readonly payload: Error;
  readonly error: boolean;
}

export interface SetSessionFulfillAction extends Action {
  readonly type: UserTypes.SET_SESSION_FULFILL;
}

export type SessionPayload = {
  readonly user: {
    readonly id: number;
    readonly email: string;
    readonly first_name: string;
    readonly surname: string;
    readonly agent_admin: boolean;
  };
}

export const setSessionTrigger: ActionCreator<SetSessionTriggerAction> = (data: SessionPayload) => ({
  type: UserTypes.SET_SESSION_TRIGGER,
  payload: data,
})

export const setSessionRequest: ActionCreator<SetSessionRequestAction> = () => ({
  type: UserTypes.SET_SESSION_REQUEST,
})

export const setSessionSuccess: ActionCreator<SetSessionSuccessAction> = (data: SessionPayload) => ({
  type: UserTypes.SET_SESSION_SUCCESS,
  payload: data,
})

export const setSessionFailure: ActionCreator<SetSessionFailureAction> = (data: Error) => ({
  type: UserTypes.SET_SESSION_FAILURE,
  payload: data,
  error: true,
})

export const setSessionFulfill: ActionCreator<SetSessionFulfillAction> = () => ({
  type: UserTypes.SET_SESSION_FULFILL,
})

export interface LoginTriggerAction extends Action {
  readonly type: UserTypes.LOGIN_TRIGGER;
  readonly payload: LoginRequest;
  readonly meta: History;
}

export interface LoginRequestAction extends Action {
  readonly type: UserTypes.LOGIN_REQUEST;
}

export interface LoginSuccessAction extends Action {
  readonly type: UserTypes.LOGIN_SUCCESS;
  readonly payload: LoginResponse;
}

export interface LoginFailureAction extends Action {
  readonly type: UserTypes.LOGIN_FAILURE;
  readonly payload: Error;
  readonly error: boolean;
}

export interface LoginFulfillAction extends Action {
  readonly type: UserTypes.LOGIN_FULFILL;
}

export type LoginRequest = {
  readonly email: string;
  readonly password: string;
}

export type LoginResponse = {
  readonly agent_admin?: boolean;
  readonly success: boolean;
}

export const loginTrigger: ActionCreator<LoginTriggerAction> = (data: LoginRequest, history: History) => ({
  type: UserTypes.LOGIN_TRIGGER,
  payload: data,
  meta: history,
})

export const loginRequest: ActionCreator<LoginRequestAction> = () => ({
  type: UserTypes.LOGIN_REQUEST,
})

export const loginSuccess: ActionCreator<LoginSuccessAction> = (data: LoginResponse) => ({
  type: UserTypes.LOGIN_SUCCESS,
  payload: data,
})

export const loginFailure: ActionCreator<LoginFailureAction> = (data: Error) => ({
  type: UserTypes.LOGIN_FAILURE,
  payload: data,
  error: true,
})

export const loginFulfill: ActionCreator<LoginFulfillAction> = () => ({
  type: UserTypes.LOGIN_FULFILL,
})

export interface LogoutTriggerAction extends Action {
  readonly type: UserTypes.LOGOUT_TRIGGER;
}

export interface LogoutRequestAction extends Action {
  readonly type: UserTypes.LOGOUT_REQUEST;
}

export interface LogoutSuccessAction extends Action {
  readonly type: UserTypes.LOGOUT_SUCCESS;
}

export interface LogoutFailureAction extends Action {
  readonly type: UserTypes.LOGOUT_FAILURE;
  readonly payload: Error;
  readonly error: boolean;
}

export interface LogoutFulfillAction extends Action {
  readonly type: UserTypes.LOGOUT_FULFILL;
}

export const logoutTrigger: ActionCreator<LogoutTriggerAction> = () => ({
  type: UserTypes.LOGOUT_TRIGGER,
})

export const logoutRequest: ActionCreator<LogoutRequestAction> = () => ({
  type: UserTypes.LOGOUT_REQUEST,
})

export const logoutSuccess: ActionCreator<LogoutSuccessAction> = () => ({
  type: UserTypes.LOGOUT_SUCCESS,
})

export const logoutFailure: ActionCreator<LogoutFailureAction> = (data: Error) => ({
  type: UserTypes.LOGOUT_FAILURE,
  payload: data,
  error: true,
})

export const logoutFulfill: ActionCreator<LogoutFulfillAction> = () => ({
  type: UserTypes.LOGOUT_FULFILL,
})

/**
 *   Forgot Actions
 */
export type ForgotRequest = {
    readonly email: string;
}

/**
 *   Forgot trigger action
 *   - payload = email address
 */
export interface ForgotTriggerAction extends Action {
    readonly type: UserTypes.FORGOT_TRIGGER;
    readonly payload: ForgotRequest;
}

export const forgotTrigger: ActionCreator<ForgotTriggerAction> = (data: ForgotRequest) => ({
    type: UserTypes.FORGOT_TRIGGER,
    payload: data,
})

/**
 *   Forgot success trigger
 */
export interface ForgotSuccessAction extends Action {
    readonly type: UserTypes.FORGOT_SUCCESS;
}

export const forgotSuccess: ActionCreator<ForgotSuccessAction> = (data: ForgotRequest) => ({
    type: UserTypes.FORGOT_SUCCESS,
})

 /**
  *   Forgot error trigger
  */
export interface ForgotErrorAction extends Action {
    readonly type: UserTypes.FORGOT_ERROR;
}

export const forgotError: ActionCreator<ForgotErrorAction> = (data: ForgotRequest) => ({
    type: UserTypes.FORGOT_ERROR,
})

/**
 * Recover password
 * - Error
 */
export const recoverpasswordError: any = (data: any) => ({
    type: UserTypes.FETCH_RECOVERPASSWORD_REJECTED,
    payload: data,
})

export interface RecoverpasswordErrorAction extends Action {
    readonly type: UserTypes.FETCH_RECOVERPASSWORD_REJECTED;
    readonly payload: any;
}

/**
 * Recover password
 * - Success
 */
export const recoverpasswordSuccess: any = (data: any) => ({
    type: UserTypes.FETCH_RECOVERPASSWORD_FULFILLED,
    payload: data,
})

export interface RecoverpasswordSuccessAction extends Action {
    readonly type: UserTypes.FETCH_RECOVERPASSWORD_FULFILLED;
    readonly payload: any;
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/user.ts